import { render } from "./index.vue?vue&type=template&id=e14f2a0a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabGolden/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e14f2a0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e14f2a0a', __exports__)) {
    api.reload('e14f2a0a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=e14f2a0a", () => {
    api.rerender('e14f2a0a', render)
  })

}


export default __exports__